import FJWebSocket from './FJWebSocket';

class FJVideoTrackSocket extends FJWebSocket {
    constructor(props) {
        super(props);
    }

    bindEvents(eventName, trackCallback) {
        this._socket.on(eventName, trackCallback);
    }

    unbindEvents(eventName) {
        this._socket.off(eventName);
    }
}

export default FJVideoTrackSocket;
